// extracted by mini-css-extract-plugin
module.exports = {"container":"Organizer_container__kJWRM","label":"Organizer_label__TRslI","value":"Organizer_value__dbZ6U"};